import { useState } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import type { InterestScore } from '../../types';
import { ScoreBreakdown } from '../ScoreBreakdown';
import './ScorePieChart.css';

interface ScorePieChartProps {
  interestScore: InterestScore;
}

export function ScorePieChart({ interestScore }: ScorePieChartProps) {
  const [showDetails, setShowDetails] = useState(false);
  
  if (!interestScore || typeof interestScore !== 'object') {
    return (
      <div className="score-pie-chart">
        <p className="text-muted">Score data not available</p>
      </div>
    );
  }

  const { total = 0 } = interestScore;
  const percentage = Math.round(total * 100);
  
  // Data for the pie chart
  const data = [
    { name: 'Interest Score', value: percentage, color: '#c9a227' },
    { name: 'Remaining', value: 100 - percentage, color: '#e5e5e5' }
  ];

  // Custom label function to show percentage in center
    return (
    <div className="score-pie-chart">
      <div className="score-pie-chart__container">
        <div className="score-pie-chart__score-display">
          <span className="score-pie-chart__percentage">{percentage}%</span>
          <span className="score-pie-chart__label">Interest Score</span>
        </div>
        
        <div className="score-pie-chart__chart-wrapper">
          <ResponsiveContainer width={140} height={140}>
            <PieChart>
              <Pie
                data={data}
                cx="50%"
                cy="50%"
                innerRadius={40}
                outerRadius={65}
                startAngle={90}
                endAngle={450}
                dataKey="value"
                stroke="none"
              >
                {data.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={entry.color} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>
        
        <button
          className="score-pie-chart__toggle"
          onClick={() => setShowDetails(!showDetails)}
          aria-expanded={showDetails}
        >
          {showDetails ? 'Hide details' : 'See more info'}
        </button>
      </div>
      
      {showDetails && (
        <div className="score-pie-chart__details animate-slide-down">
          <ScoreBreakdown interestScore={interestScore} />
        </div>
      )}
    </div>
  );
}